import {Button} from 'antd';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {useTableFilters} from '../../contexts/TableFiltersContext';
import FilterList from '../FilterList';

const FilterArea = ({translation}) => {
  const {t} = useTranslation(translation);
  const {activeFilters, onClearAllActiveFilter} = useTableFilters();

  return <div className="lg:px-2 py-2 lg:py-0 flex flex-col lg:flex-row flex-grow lg:items-center">
    <FilterList t={t}/>
    <div className="flex justify-between py-2 lg:py-0">
      <div>
        {!isEmpty(activeFilters) && <Button type="text" onClick={onClearAllActiveFilter}>{t('clearAll')}</Button>}
      </div>
    </div>
  </div>;
};

FilterArea.propTypes = {
  translation: PropTypes.string,
};

export default memo(FilterArea);
